export const THEME_SUCCESS = "THEME_SUCCESS";
export const THEME_FAIL = "THEME_FAIL";
